module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "chaptitler-a"
  }, [_c('a', {
    attrs: {
      "id": "page_45"
    }
  }), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Old Egypt")])]), _vm._v(" "), _c('h3', {
    staticClass: "chaptitle1-a",
    attrs: {
      "id": "ch2-7"
    }
  }, [_vm._v("KING THUTMOSE III’S INSTRUCTIONS TO CHIEF JUSTICE REKHMIRE"), _c('a', {
    attrs: {
      "href": "#/xhtml/16_Chapter027#rch2fn7",
      "id": "ch2fn7"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-as1"
  }, [_vm._v("One of the most impressive passages in the history of world justice is a speech of instruction purported to have been announced by King Thutmose III, who ruled Egypt around 1500 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C")]), _vm._v(". and at the height of Egypt’s power. These instructions were found recorded on the tomb of Chief Justice Rekhmire and were supposedly uttered when he was appointed by Thutmose to the post of Chief Judge of the kingdom.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Regulation laid upon the chief judge, Rekhmire. The officials were brought to the audience-hall; his majesty commanded that the chief judge, Rekhmire, be presented for appointment for the first time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("His majesty spake before him: “Take heed to thyself for the hall of the chief judge; be watchful over all that is done therein. Behold, it is a support of the whole land; behold, as for the chief judge, behold, he is not sweet, behold, bitter is he, when he speaks…. Behold, he is not one setting his face toward the officials and councilors neither one making brethren of all the people…. Mayest thou see to it for thyself, to do everything after that which is in accordance with law; to do everything according to the right thereof … lo, it is the safety of an official to do things according to the law, by doing that which is spoken by the petitioner….")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It is an abomination of the god to show partiality. This is the teaching: thou shalt act alike to all, shalt regard him who is known to thee like him who is unknown to thee, and him who is near to … like him who is far…. An official who does this, then shall he flourish greatly in the place.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do not avoid a petitioner, nor yet nod thy head when he speaks. As for him who draws near, who will approach to thee, do not … the things which he saith in speaking. Thou shalt punish him when thou hast let him hear that on account of which thou punishest him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Be not enraged toward a man unjustly, but be thou enraged concerning that about which one should be enraged.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Show forth the fear of thee; let one be afraid of thee, for a prince is a prince of whom one is afraid. Lo, the true dread of a prince is not to do justice.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“… Thou shalt do thy office, as thou doest justice. Lo, one shall desire to do justice…. Lo, one shall say of the chief scribe of the chief judge: ‘A scribe of justice,’ shall one say of him.”")]), _vm._v(" "), _c('p', {
    staticClass: "note-a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/16_Chapter027#ch2fn7",
      "id": "rch2fn7"
    }
  }, [_vm._v("*")]), _vm._v(" From the translation in Breasted, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ancient Records")]), _vm._v(", II, 666–670.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39c62194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/16_Chapter027.vue
// module id = 114
// module chunks = 0